import { g as r } from "./global.js";
import { d as o } from "./define-global-property.js";
var s = "__core-js_shared__",
  a = r[s] || o(s, {});
export { a as s };